import type { AuthUser } from "@kuroo/contracts";

export const navItems = [
  ["/dashboard", "Dashboard", "⌂"], ["/leads", "Leads", "◎"], ["/calendar", "Calendario", "▦"], ["/bookings", "Reservas", "◷"], ["/services", "Servicios", "◆"], ["/locations", "Ubicaciones", "⌖"],
  ["/reports", "Reportes", "▤"],
  ["/events", "Eventos", "◇"], ["/customers", "Clientes", "◎"], ["/team", "Equipo", "◌"], ["/payments", "Pagos", "€"], ["/coupons", "Cupones", "%"],
  ["/availability-requests", "Solicitudes de agenda", "✓"],
  ["/messaging", "Mensajería", "✦"], ["/integrations", "Integraciones", "↗"], ["/concierge", "Concierge IA", "✧"], ["/settings", "Configuración", "⚙"], ["/transfers", "Transferencias", "⇄"],
  ["/security", "Seguridad enterprise", "⌁"], ["/onboarding", "Provisioning", "◈"], ["/ui-lab", "UI Lab", "✦"], ["/public-profile", "Mi página pública", "◉"]
] as const;

export const routeRoles: Record<string, readonly AuthUser["role"][]> = {
  "/dashboard": ["admin", "manager", "provider"],
  "/leads": ["admin", "manager"],
  "/calendar": ["admin", "manager", "provider"],
  "/bookings": ["admin", "manager", "provider"],
  "/services": ["admin", "manager", "provider"],
  "/locations": ["admin", "manager"],
  "/reports": ["admin", "manager"],
  "/events": ["admin", "manager"],
  "/customers": ["admin", "manager"],
  "/team": ["admin", "manager"],
  "/availability-requests": ["admin", "manager"],
  "/payments": ["admin", "manager"],
  "/coupons": ["admin", "manager"],
  "/messaging": ["admin", "manager"],
  "/integrations": ["admin"],
  "/concierge": ["admin"],
  "/settings": ["admin", "manager"],
  "/security": ["admin"],
  "/transfers": ["admin"],
  "/onboarding": ["admin", "manager"],
  "/ui-lab": ["admin", "manager"],
  "/public-profile": ["admin", "manager", "provider"]
};

export function canAccessRoute(path: string, role: AuthUser["role"]): boolean {
  const root = `/${path.split("/").filter(Boolean)[0] ?? "dashboard"}`;
  return !routeRoles[root] || routeRoles[root].includes(role);
}
